import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useParams, NavLink } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { defaultOption } from "constants/ui/options";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getEmpFullNameTHByEmpData, getSupplierFullName, getSupplierMainContactFullName, isOrderOverDue, mapMstToOptions, pageInitSize, pageSizeOptions } from "utils/HelperFunction";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Postatus } from "fragments/POStatus";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllNewPurchaseOrder } from "../../redux/handlers/logic/getAllNewPurchaseOrder.handler";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { debounce } from "@mui/material";
export function POList() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState1[0], setPageModel = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        1: 0,
        2: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        overdue: 0
    }), 2), poStatusCount = _useState2[0], setPoStatusCount = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), tab = _useState3[0], setTab = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), tab0 = _useState4[0], setTab0 = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), tab1 = _useState5[0], setTab1 = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tab2 = _useState6[0], setTab2 = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), tab3 = _useState7[0], setTab3 = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), tab4 = _useState8[0], setTab4 = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), tab5 = _useState9[0], setTab5 = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), tab6 = _useState10[0], setTab6 = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), Alldata = _useState11[0], setAlldata = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState12[0], setOptionsDistributorgroup = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState13[0], setOptionsGroupOfSuplier = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState14[0], setSelectedGroupOfSuplierID = _useState14[1];
    var _useState15 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState15[0], setGroupOfSupplier = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState16[0], setDistributorgroup = _useState16[1];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewPurchaseOrderReducer = useAppSelector(function(state) {
        return state.getAllNewPurchaseOrderReducer;
    });
    // const getData = () => {
    //     fetch('/json/po.json')
    //       .then((response) => response.json())
    //       .then((result) => {
    //         setData(result);
    //         setTab(result);
    //         const status0 = result.filter(item => item.status === 0 );
    //         const status1 = result.filter(item => item.status === 1 );
    //         const status2 = result.filter(item => item.status === 2 );
    //         const status3 = result.filter(item => item.status === 3 );
    //         const status4 = result.filter(item => item.status === 4 );
    //         const status5 = result.filter(item => item.status === 5 );
    //         const status6 = result.filter(item => item.status === 6 );
    //         setTab0(status0)
    //         setTab1(status1)
    //         setTab2(status2)
    //         setTab3(status3)
    //         setTab4(status4)
    //         setTab5(status5)
    //         setTab6(status6)
    //       })
    //       .catch((error) => console.log("error", error));
    // };
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function(page, limit, searchText, groupSubID, mstNewStatusID) {
        var mstNewStatusIDModify = mstNewStatusID === "overdue" ? 4 : mstNewStatusID;
        var queryParams = {
            mstNewStatusID: mstNewStatusIDModify,
            page: page,
            limit: limit,
            searchText: searchText,
            groupSubID: groupSubID,
            isOrderOverDueStatus: mstNewStatusID === "overdue"
        };
        dispatch(getAllNewPurchaseOrder({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadAllMsts();
        getData(1, pageModel.pageSize, "", "", "", "");
    }, []);
    var _useState17 = _sliced_to_array(useState(null), 2), filterText = _useState17[0], setFilterText = _useState17[1];
    // let filteredItems = data.filter((item) => {
    //   const docNumberMatches =
    //     item.doc_number &&
    //     item.doc_number.toLowerCase().includes(filterText.toLowerCase());
    //   const supplierNameMatches =
    //     item.dimSupplierInformation &&
    //     getSupplierFullName(item.dimSupplierInformation)
    //       .toLowerCase()
    //       .includes(filterText.toLowerCase());
    //   const supplierGroupMatches =
    //     !selectedGroupOfSuplierID ||
    //     (item.dimSupplierInformation &&
    //       item.dimSupplierInformation.dimGroupOfSupplier &&
    //       selectedGroupOfSuplierID ===
    //         item.dimSupplierInformation.dimGroupOfSupplier.id);
    //   return (docNumberMatches || supplierNameMatches) && supplierGroupMatches;
    // });
    var _useState18 = _sliced_to_array(useState(null), 2), btnempstatus = _useState18[0], setBtnempstatus = _useState18[1];
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewPurchaseOrderReducer.isFetching);
        if (getAllNewPurchaseOrderReducer.data) {
            var result = getAllNewPurchaseOrderReducer.data.data.data;
            var meta = getAllNewPurchaseOrderReducer.data.data.meta;
            var poStatusCount = getAllNewPurchaseOrderReducer.data.data.poStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            // console.log(result)
            setTab(result);
            setPoStatusCount(function(prev) {
                return _object_spread({}, prev, poStatusCount);
            });
        // const status1 = result.filter((item) => item.dim_mst_new_status_id === 1);
        // const status2 = result.filter((item) => item.dim_mst_new_status_id === 2);
        // const status4 = result.filter((item) => item.dim_mst_new_status_id === 4);
        // const statusOverDue = result.filter(
        //   (item) =>
        //     item.dim_mst_new_status_id === 4 &&
        //     isOrderOverDue(item.delivery_date, item.delivery_time)
        // );
        // const status5 = result.filter((item) => item.dim_mst_new_status_id === 5);
        // const status6 = result.filter((item) => item.dim_mst_new_status_id === 6);
        // const status7 = result.filter((item) => item.dim_mst_new_status_id === 7);
        // setTab0(status1);
        // setTab1(status2);
        // setTab2(status4);
        // setTab3(statusOverDue);
        // setTab4(status5);
        // setTab5(status6);
        // setTab6(status7);
        }
    }, [
        getAllNewPurchaseOrderReducer
    ]);
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่เอกสาร PO",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/purchase/order/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "dimNewPurchaseReq",
            headerName: "เลขที่เอกสาร PR",
            width: 200,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return row.dimNewPurchaseReq ? /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/purchase/requisition/edit/".concat(row.dimNewPurchaseReq.id),
                    target: "_blank",
                    children: row.dimNewPurchaseReq.doc_number
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: "-"
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จำหน่าย",
            width: 250,
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "delivery_date",
            headerName: "วันที่จัดส่ง",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.delivery_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dimMstPaymentType",
            headerName: "เงื่อนไขชำระเงิน",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimMstPaymentType ? row.dimMstPaymentType.name : "-"
                });
            }
        },
        {
            field: "qty_sum",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            cellClassName: "d-flex justify-content-end",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        },
        {
            field: "dim_new_alldernow_emp_id",
            headerName: "ผู้สร้างเอกสาร",
            width: 220,
            align: "center",
            headerAlign: "center",
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: getEmpFullNameTHByEmpData(row.createdNewPoEmp)
                });
            }
        },
        {
            headerName: "สถานะ",
            field: "dimMstNewStatus",
            headerAlign: "center",
            align: "center",
            width: 190,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row ? row.dimMstNewStatus.id : "";
                var statusName = row ? row.dimMstNewStatus.name : "";
                return /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col",
                    children: [
                        isOrderOverDue(row.delivery_date, row.delivery_time) && statusID == 4 && /*#__PURE__*/ _jsx(Postatus, {
                            status: "overdue"
                        }, "status-".concat(row.id, "-overdue")),
                        row.dimMstNewStatus.id == 6 && row.is_force_success && /*#__PURE__*/ _jsx(Postatus, {
                            status: "force-success"
                        }, "status-".concat(row.id, "-overdue")),
                        /*#__PURE__*/ _jsx(Postatus, {
                            status: statusID
                        }, "status-".concat(row.id))
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ใบสั่งซื้อ PO",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "ใบสั่งซื้อ PO"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == null ? " active" : "", " "),
                                onClick: function() {
                                    setBtnempstatus(null);
                                // setData(tab);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 1 ? " active" : "", "  "),
                                onClick: function() {
                                    setBtnempstatus(1);
                                // setData(tab0);
                                },
                                children: "แบบร่าง"
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 2 ? " active" : "", "  "),
                                onClick: function() {
                                    setBtnempstatus(2);
                                // setData(tab1);
                                },
                                children: [
                                    "รออนุมัติ (",
                                    poStatusCount["2"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 4 ? " active" : "", " "),
                                onClick: function() {
                                    setBtnempstatus(4);
                                // setData(tab2);
                                },
                                children: [
                                    "รอรับสินค้า (",
                                    poStatusCount["4"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == "overdue" ? " active" : "", "  text-[#FF0000]"),
                                onClick: function() {
                                    setBtnempstatus("overdue");
                                // setData(tab3);
                                },
                                children: [
                                    "เกินกำหนด (",
                                    poStatusCount["overdue"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 5 ? " active" : "", "  "),
                                onClick: function() {
                                    setBtnempstatus(5);
                                // setData(tab4);
                                },
                                children: [
                                    "รับสินค้าบางส่วน (",
                                    poStatusCount["5"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 6 ? " active" : "", "  "),
                                onClick: function() {
                                    setBtnempstatus(6);
                                // setData(tab5);
                                },
                                children: "เสร็จสิ้น"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-category px-4 ".concat(btnempstatus == 7 ? " active" : "", "  "),
                                onClick: function() {
                                    setBtnempstatus(7);
                                // setData(tab6);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "ใบสั่งซื้อ PO"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/purchase/order/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "สร้างใบสั่งซื้อ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: getAllNewPurchaseOrderReducer.isFetching,
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData(newPagination.page + 1, newPagination.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: columnsd,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
